import { Helmet } from 'react-helmet-async';
import '../App.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const POWERBI_BASE = 'https://app.powerbi.com/view?r=';
// REPLACE THIS with the home’s publish-to-web report token (the `r=` value only).
const WEEKLY_MENU_REPORT_ID =
  'eyJrIjoiYTkzNTc0MjEtNTZhYy00NjVmLTk5YzUtZmY3NGQ2MzY4ZTJmIiwidCI6ImUzNmQ3NWZhLWU4NjItNDAyMC05MzllLTU0YjFiNDQ2NGFlMSJ9';
const weeklyMenuSrc = `${POWERBI_BASE}${WEEKLY_MENU_REPORT_ID}&navContentPaneEnabled=false&filterPaneEnabled=false`;

function WeeklyMenus() {
  return (
    <>
      <Helmet>
        <title>Our Food</title>
        <meta
          name="description"
          content="Weekly menus at Harpwood House."
        />
        <link rel="canonical" href="https://www.harpwood.house/weekly-menus" />
      </Helmet>

      <div className="page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />

        <main id="main-content">
          <section className="content-section weekly-menus-page">
            <div className="weekly-menus-container">
              <h1>Our Food</h1>

              <section className="food-report">
                <div className="food-report__frame">
                  <iframe
                    title="Harpwood House Food Dashboard Weekly Menu"
                    src={weeklyMenuSrc}
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              </section>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}

export default WeeklyMenus;
